/*
 * Product identity for the React UI. V1 = the Thymeleaf pages inside the Spring server,
 * V2 = the retired Python/FastAPI product (NecroMancerV2), V3 = this UI, which talks to the
 * Spring server over /uiapi. CRA does not let src/ import package.json, so the version lives here
 * and package.json mirrors it.
 */
/* The "3" is in the name on purpose (launch hype - owner, 2026-08-23). Code and docs say "V3". */
export const PRODUCT_NAME = 'NecroMancer 3';
export const PRODUCT_GENERATION = 'V3';
export const PRODUCT_SHORT = 'NM3';
export const PRODUCT_VERSION = '3.0.0';
export const PRODUCT_TAGLINE = 'Slots, phones, sessions and settings for every account you run - in one place, on your own server.';
export const BRAND_LOGO = '/brand/logo-mark.png'; // the reaper - NecroMancerIG.png from the Spring server
export const BRAND_LOGO_GLOW = '/brand/logo-glow.png';
